/* eslint-disable */
const errorHandlerService = function (message, errorObj) {
	if (typeof console != "undefined" && typeof console.log == "function") {
		console.log('Something wrong');
		console.log(message);
		if(errorObj?.errorThrown) {
			console.log(errorObj.errorThrown);
		}
	}

	return this;
};

export default errorHandlerService;